import remarkBreaks from "remark-breaks";
function breaks() {
  return {
    remark: (processor) => processor.use(remarkBreaks)
  };
}
export {
  breaks as default
};
